import template	from "./dialog-config-illumination.html";
import css		from "./dialog-config-illumination.css";

import Dialog	from "dialog";


class ConfigIlluminationDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-illumination", ConfigIlluminationDialog);
  }
  constructor(...args) {
    super(...args);

    this.show(...args);
  }
  async rangeRed_change() {
  }
  async rangeGreen_change() {
  }
  async rangeBlue_change() {
  }
  buttonClose_click() {
    this.close();
  }
}

ConfigIlluminationDialog.constructor();

export default ConfigIlluminationDialog;